export const oldDataTimeout = 15
export const refreshRate = 2000
export const serverUrl = 'https://jpfmobile.mimatech.ch'
export const imagesProxyUrl = 'https://jpfimages.mimatech.ch'
